import React, { Fragment } from 'react'
import { Alert, Button } from 'react-bootstrap'
import { NavLink, Redirect } from "react-router-dom"
import { makeStyles } from '@material-ui/core/styles'

import '../../resources/css/restore_wallet.css'

import Constants from '../../config.js'
import {
    UserContext, get_all_wallet_backups_from_localcache,
    save_localcache_encrypted_wallet_backup
} from "../../Contexts/UserContext/UserContext.js"
import { Loader } from '../../components/Loader'
import { deepcopy } from '../../helpers/helpers.js'
import { ButtonPrimaryOutlined } from '../../components/Buttons.js'
import { UploadButton } from '../../components/DownloadUploadButton/DownloadUploadButton'



const useStyles = makeStyles((theme) => ({
    darkBlueButton: {
        backgroundColor: "#3f4b56",
        "&:hover, &:focus": {
            backgroundColor: "#566776",
        }
    },
}))



// TODO move this component and its associated styles to its own component file + add to storybook
export const DarkBlueButton = (props) => {
    var { children, style, ...other_props } = { ...props }
    const classes = useStyles()

    return (
        <Button {...other_props} className={classes.darkBlueButton} style={{ ...style }}>
            {children}
        </Button>
    )
}



// TODO convert into a functional component
class Restore_Wallet_From_File extends React.Component {

    static contextType = UserContext  // context

    constructor(props) {
        super(props)
        this.classname = "Restore_Wallet_From_File: "

        this.state = {
            redirect: false,
            wallet_backups: [],
            forceFileContent: null,  // for clicks on backedup files
        }

        this.onGetContent = this.onGetContent.bind(this)
    }


    async onGetContent(decryptedcontent, password = null, rememberDevice = false) {
        const function_id = this.classname + "onGetContent(): "
        const log = (...args) => { console.log(function_id, ...args) }

        log("start")

        var myjson = decryptedcontent
        if (decryptedcontent.mnemonic === "undefined") {
            myjson = JSON.parse(decryptedcontent)
        }

        var mnemonic = myjson.mnemonic
        var walletname = myjson.walletname
        var network = myjson.network

        try {
            await this.context.update_wallet_name(walletname)
            // stash the password + rememberDevice flag so update_from_mnemonic_noreload
            // can save an encrypted session blob for stay-logged-in-across-refresh
            if (password) {
                this.context.setWalletPassword(password, rememberDevice)
            }
            await this.context.update_from_mnemonic_noreload(mnemonic, network)
            // don't load the wallet here, just update the keys and we'll load it once we display a loader on next page

            if (!Constants.IS_WEB_BUILD) {
                // save a local copy in the app path cache for future reopenings
                var data_to_backup = deepcopy(myjson)
                delete data_to_backup["mnemonic"]  // only remove the decrypted mnemonic
                log("saving backup in local cache, address=", this.context.address_owner)
                save_localcache_encrypted_wallet_backup(this.context.address_owner, data_to_backup)
            }

            // wallet loaded, now redirect user
            this.setState({ redirect: true })
        }
        catch (error) {
            var errormess = "restore_wallet_from_file: onGetContent(): " + error
            log(errormess, error)

            if (!Constants.IS_WEB_BUILD) { // electron app
                window.electron.openDialogShowMessageBox({ title: "Erreur", message: errormess })
            } else { // web
                alert(errormess);
            }
            throw errormess
        }
    }

    async componentDidMount() {

        var wallet_backups = get_all_wallet_backups_from_localcache()

        var jsx_wallet_backups = null
        /* example:
            walletname:
            filecreationdate: 23/03/2021, 01:42:57
            filename: 1FTZhwMbVgzz5kWiFrcujzz2rR3KUJHj7v_walletBackup
            last_saved: 1616460177879
        */
        wallet_backups.forEach(wallet_backup => {
            jsx_wallet_backups =
                <Fragment>
                    <div>
                        <DarkBlueButton variant="dark" style={{ cursor: "pointer", padding: "0.5em", width: "80%", marginLeft: "10%" }}
                            onClick={() => this.setState({ forceFileContent: JSON.stringify(wallet_backup) })}
                        >
                            {wallet_backup.walletname || "unnamed wallet"}<br />
                            {wallet_backup.owner_address}<br />
                            Ouvert le {(new Date(parseInt(wallet_backup.last_saved, 10))).toLocaleString("fr-FR")}
                        </DarkBlueButton>
                    </div><br />

                    {jsx_wallet_backups}
                </Fragment>
        })

        jsx_wallet_backups = <div style={{}}>{jsx_wallet_backups}</div>

        console.log(this.classname, " wallet_backups=", wallet_backups)
        this.setState({ wallet_backups: jsx_wallet_backups })
    }


    render() {
        const function_id = this.classname + "render(): "
        const log = (...args) => { console.log(function_id, ...args) }

        if (this.state.redirect === true) {
            log("redirecting to display_wallet")
            return (
                <Redirect to="/wallet" push /> //push to not reload page
            )
        }

        var popup_password_wallet = null
        log("!!this.state.forceFileContent=", !!this.state.forceFileContent)
        let loading_info_jsx = <span><br />
            Chargement en cours... <Loader small />
        </span>
        if (this.state.forceFileContent) {
            popup_password_wallet =
                <UploadButton
                    getDecryptedContent={this.onGetContent}
                    forceFileContent={this.state.forceFileContent}
                    loading_info_jsx={loading_info_jsx}
                    onCloseButtonClicked={() => { this.setState({ forceFileContent: null }) }}
                />
        }

        return (
            <div className="mode-selection-style" style={{ float: "none" }}>
                <h2>
                    <br />
                    {Constants.RESTORE_WALLET_PAGE}
                </h2> <br />

                <p className="main-text-page">
                    {Constants.RESTORE_WALLET_TXT}
                </p>

                <div style={{ padding: "4%", margin: "0 auto", width: "fit-content" }}>
                    <UploadButton getDecryptedContent={this.onGetContent}
                        loading_info_jsx={loading_info_jsx}
                        onCloseButtonClicked={() => { this.setState({ forceFileContent: null }) }}
                    />
                </div>

                {popup_password_wallet}

                {this.state.wallet_backups}

                <div className="bottom-buttons">
                    <div className="return-button">
                        <NavLink className="return-logo" to="/select_wallet">
                            <ButtonPrimaryOutlined>
                                Back
                            </ButtonPrimaryOutlined>
                        </NavLink>
                    </div>
                </div>

                {/* make it easier to scroll if needed */}
                <div style={{ height: "40vh" }}>&nbsp;</div>

            </div>
        );
    }
}

export default Restore_Wallet_From_File
